<template>
  <div class="product-information">
    <div class="custom-spus">
      <div class="card">
        <div class="content">
          <div class="aside">
            <div class="top">
              <div ref="bigContainer"
                   class="big">
                <ImageCustomizeEditor v-if="currentCustomizedImage &&
                  bigContainer &&
                  bigContainer.offsetHeight &&
                  bigContainer.offsetWidth"
                                      :id="currentCustomizedImage.customableImage.id + ''"
                                      :key="currentCustomizedImage.customableImage.id + ''"
                                      mode="view"
                                      :container="bigContainer"
                                      :template-basic-parameters="templateBasicParameters(currentCustomizedImage.customableImage)"
                                      :custom-area="assignDssProductCustomizedData(currentCustomizedImage)"
                                      :customized-image="renderDssProductImageCustomUrl(currentCustomizedImage)" />
              </div>
            </div>
            <div v-if="currentCustomSpuData"
                 class="thumbnail">
              <div ref="thumbnailContainer"
                   class="hidden"></div>
              <div v-for="(item, index) in currentCustomSpuData.customizedImages"
                   :key="`thumbnail-container-${item.id}-${index}`"
                   class="thumbnail-container"
                   @click="onSelectCustomizedImages(item)">
                <ImageCustomizeEditor v-if="thumbnailWrapper &&
                  thumbnailWrapper.width &&
                  thumbnailWrapper.height
                  "
                                      :id="`Product-${item.id}-${index}`"
                                      :ref="createEditorRef"
                                      mode="view"
                                      :container="thumbnailContainer"
                                      :template-basic-parameters="templateBasicParameters(item.customableImage)"
                                      :custom-area="assignDssProductCustomizedData(item)"
                                      :customized-image="renderDssProductImageCustomUrl(item)" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="product">
      <div v-if="currentCustomSpuData"
           class="options">
        <p>{{ $t('DesignShare.DssAddToCart.shareDesign') }}:</p>
        <div class="product-select">
          <a-space>
            <a-select v-model:value="currentSelectedCategory"
                      :field-names="{ label: 'name', value: 'name' }"
                      :options="productTypes"
                      @select="selectedCategory"></a-select>
            <a-select v-model:value="currentSelectedSpu"
                      :field-names="{ label: 'name', value: 'name' }"
                      :options="productTypes.find((r: DssProductCategories) => r.name === currentSelectedCategory)?.spu"
                      @select="selectedSpu"></a-select>
          </a-space>
        </div>
        <p class="colorTitle">{{ $t('DesignShare.DssAddToCart.color') }}:</p>
        <div class="colors">
          <div ref="hiddenContainerColor"
               class="hidden"></div>
          <template v-for="item in colors">
            <a-tooltip>
              <template #title>{{ item.name }}</template>
              <div v-if="alt_image.find((alt: any) => alt.color.value == item.value)">
                <div v-for="alt in alt_image">
                  <img v-if="alt.color.value == item.value"
                       :src="alt.alt_image"
                       :class="['color-item', selectedColor?.value === item.value ? 'color-selected' : '']"
                       @click="colorChange(item)" />
                </div>
              </div>
              <div v-else-if="alt_image.length < 1">
                <div :class="['color-item', selectedColor?.value === item.value ? 'color-selected' : '']"
                     :style="{ background: item.value, backgroundImage: `url(${item.image})` }"
                     @click="colorChange(item)"></div>
              </div>
            </a-tooltip>
          </template>
        </div>
        <p class="sizeTitle">{{ $t('DesignShare.DssAddToCart.size') }}:</p>
        <div class="size-content">
          <div v-for="item in sizes"
               :key="item"
               :class="['size-item', selectedSize === item ? 'size-selected' : null]"
               @click="sizeChange(item)">
            <span>{{ item }}</span>
          </div>
        </div>
        <p class="countTitle">{{ $t('DesignShare.DssAddToCart.quantity') }}:</p>
        <a-input v-model:value="quantity"
                 class="quantity-input">
          <template #addonBefore>
            <div class="input-change"
                 :class="quantity <= 1 ? 'input-disabled' : ''"
                 @click="quantity <= 1 ? '' : qualityChange('minus')">
              <minus-outlined :class="quantity <= 1 ? 'input-disabled' : ''" />
            </div>
          </template>
          <template #addonAfter>
            <div class="input-change"
                 :class="quantity > 100000 ? 'input-disabled' : ''"
                 @click="quantity > 100000 ? '' : qualityChange('plus')">
              <plus-outlined :class="quantity > 100000 ? 'input-disabled' : ''" />
            </div>
          </template>
        </a-input>
        <div v-for="item in customSpu?.price_detail.custom_price"
             :key="item.id">
          <div class="technology countTitle">
            <span>{{ item.name + '(' + item.customized_areas_scale_title + ')' }}
              {{ $t('DesignShare.DssAddToCart.craftsmanship') }}:</span>
            <a-radio-group v-model:value="item.technology"
                           class="technology-radio">
              <a-radio v-for="(ite, index) in item.technologies"
                       :key="index"
                       :value="ite">{{ ite.name }}</a-radio>
              <a-radio v-if="item.technologies?.length === 0"
                       :value="item.technology!">{{
                         item.technology!.name
                       }}</a-radio>
            </a-radio-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ImageCustomizeEditor } from '@iota-cn/ui-components'
// import ImageCustomizeEditor from "./ImageCustomizeEditor.vue"
import { message } from 'ant-design-vue'
import BigNumber from "bignumber.js"
import { computed, ref, watch } from 'vue'
import { useShoppingCart } from '../..'
import type { CartData, CartDataSku, Color, CustomizedImage, AltImage, CustomSpu, CustomPriceDetail, CustomPrice, Technology, DssProductCategories, RawCustomizedImage } from '../configure'
import { convertSpuToSimpleSpu, convertToCustomizedImage, findCustomableImage, sortBy, templateBasicParameters, assignDssProductCustomizedData, renderDssProductImageCustomUrl } from '../utill'
import { PLUGIN_ACCOUNT_INFO } from "@/plugins/builtin/BuiltinPluginSymbol"
import { container } from "tsyringe"
import type { Plugin } from "@/plugins"
import type { AccountBaseInfoOption, AccountInfoService } from '../../account-info/index'
import { useI18n } from 'vue-i18n'
BigNumber.config({ ROUNDING_MODE: 1 })
const shoppingCart = useShoppingCart()
const currentCustomSpuData = ref<CustomSpu>()
const { t } = useI18n()
const currentCustomizedImage = ref<RawCustomizedImage>()
const customSpu = ref<CartData | undefined>()
const quantity = ref(1)
const selectedCustomSkus = ref<CartDataSku[]>([])
const filterByColorCustomSkus = ref<CartDataSku[]>([])
const thumbnailContainer = ref()
const bigContainer = ref()
const hiddenContainerColor = ref()
const currentSelectedCategory = ref<string>('')
const currentSelectedSpu = ref<string>('')
const accountInfoPlugin = container.resolve<Plugin<AccountBaseInfoOption, AccountInfoService>>(PLUGIN_ACCOUNT_INFO)
const baseDiscount = accountInfoPlugin.options.baseDiscount.value
const productTypes = ref<DssProductCategories[]>([])
const customSpusList = ref<CustomSpu[]>()
const filterSkusByColor = (color: Color, arr: CartDataSku[]) => {
  const r = arr.filter(k => {
    return k.color?.value === color.value
  })
  return r
}
const qualityChange = (event: any) => {
  switch (event) {
    case 'minus':
      quantity.value--
      break
    case 'plus':
      quantity.value++
      break
  }
}
// @Todo change to computed?
const colors = ref<Color[]>([])
const selectedColor = ref<Color>()
const selectedSize = ref<string>('')

watch(() => [selectedColor.value, selectedSize.value], () => {
  if (!customSpu.value)
    return
  let selectShape: any
  if (customSpu.value.skus) {
    selectShape = customSpu.value.skus?.find((r: any) => r.color.value == selectedColor.value?.value && r.size == selectedSize.value)
    if (selectShape) {
      if (selectShape.price)
        customSpu.value.price_detail.sku_price = new BigNumber(selectShape.price).toFixed(2) as any
      if (selectShape.sku && selectShape.sku.price)
        customSpu.value.price_detail.sku_price = new BigNumber(selectShape.sku.price).toFixed(2) as any
    }
  }
  quantity.value = 1
})

const onSelectCustomizedImages = (value: RawCustomizedImage) => {
  currentCustomizedImage.value = value
}

const selectedCategory = () => {
  if (customSpusList.value) {
    customSpusList.value.forEach((r: CustomSpu) => {
      if (r.spu.category.name === currentSelectedCategory.value) {
        currentSelectedSpu.value = r.spu.name!
        conversionSpuData(r)
      }
    })
  }
}

const selectedSpu = () => {
  if (customSpusList.value) {
    customSpusList.value.forEach((r: CustomSpu) => {
      if (r.spu.name === currentSelectedSpu.value) {
        conversionSpuData(r)
      }
    })
  }
}

// 小图dom数组
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const allImageEditors: any = {}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const createEditorRef = computed(() => (value: any) => {
  if (value) {
    const id = value.editorId()
    allImageEditors[id] = value
  }
})

const thumbnailWrapper = computed(() => {
  return thumbnailContainer.value
    ? {
      value: thumbnailContainer.value,
      width: thumbnailContainer.value.offsetWidth,
      height: thumbnailContainer.value.offsetHeight
    }
    : undefined
})

const colorChange = (value: Color) => {
  selectedColor.value = value
  filterByColorCustomSkus.value = filterSkusByColor(selectedColor.value, customSpu.value?.skus || [])
  sizes.value = filterByColorCustomSkus.value.map(sku => {
    const skuAttrs = sku.sku?.attrs as any
    return (skuAttrs?.find((a: any) => {
      return a.attribute.key === 'size'
    }) || {}).value || ''
  }).filter(s => {
    return s != ''
  })
  sizeSort(sizes.value)
  if (sizes.value.length > 0) {
    const select = selectedSize.value && sizes.value.includes(selectedSize.value) ? selectedSize.value : sizes.value[0]
    sizeChange(select)
  }
  if (currentCustomSpuData.value) {
    currentCustomSpuData.value.customizedImages.forEach((res: RawCustomizedImage) => {
      if (res.customableImage && res.customableImage.altImages) {
        const currentBackgroundImage = res.customableImage.altImages.find((r: AltImage) => r.attrs![0].object_value.value === value.value)
        if (currentBackgroundImage) {
          res.customableImage.image = currentBackgroundImage.alt_image
        }
      }
    })
  }
  if (currentCustomizedImage.value?.customableImage.altImages) {
    const currentBackgroundImage = currentCustomizedImage.value?.customableImage.altImages.find((r: AltImage) => r.attrs![0].object_value.value === value.value)
    if (currentBackgroundImage) {
      currentCustomizedImage.value!.customableImage.image = currentBackgroundImage?.alt_image
    }
  }
}
const sizeSort = (arr: any) => {
  arr.sort((attrA: any, attrB: any) => {
    const sizeValueA = attrA.match(/\d+(\.\d+)?/g)
    const sizeValueB = attrB.match(/\d+(\.\d+)?/g)
    if (sizeValueA[0] < sizeValueB[0]) {
      return -1
    }
    if (sizeValueA[0] > sizeValueB[0]) {
      return 1
    }
    return 0
  })
  return arr
}
const filterSkus = (key: string, value: string, arr: CartDataSku[]) => {
  return arr.filter(k => {
    const skuAttrs = k.sku?.attrs as any
    return skuAttrs.find((a: any) => {
      return a.attribute.key === key && a.value === value
    })
  })
}

const sizes = ref<string[]>([])
const sizeChange = (value: string) => {
  selectedSize.value = value
  selectedCustomSkus.value = filterSkus('size', selectedSize.value, filterByColorCustomSkus.value)
}

const image = ref<CustomizedImage>()
const alt_image = ref<any>()
// 显示
const setProduct = async (value: CustomSpu[], category_id: number) => {
  customSpusList.value = value
  value.forEach((r: CustomSpu) => {
    const findCategory = productTypes.value.find((res: DssProductCategories) => res.id === r.spu.category.id)
    if (!findCategory) {
      productTypes.value.push({
        id: r.spu.category.id,
        name: r.spu.category.name,
        spu: [{
          id: r.spu.id!,
          name: r.spu.name!,
          technology: r.spu.technology
        }]
      })
    } else {
      findCategory.spu.push({
        id: r.spu.id!,
        name: r.spu.name!,
        technology: r.spu.technology
      })
    }
  })
  // 默认为第一个Category和第一个spu
  const findCurrentCategory = value.find((res: any) => res.spu.category_id === category_id)
  if (findCurrentCategory) {
    currentSelectedCategory.value = findCurrentCategory.spu.category.name
    currentSelectedSpu.value = findCurrentCategory.spu.name!
    conversionSpuData(findCurrentCategory)
  }
}

const conversionSpuData = async (value: CustomSpu) => {
  currentCustomSpuData.value = value
  const data = {
    is_custom: true,
    spu_id: value.spu_id,
    name: value.name,
    spu_name: value.spu.name as string,
    customizedImages: value.customizedImages,
    image: "",
    skus: value.customSkus,
    custom_spu_id: value.id,
    price_detail: value.price_detail,
    references: value.references
  }
  customSpu.value = data
  await structurePriceDetail(value)
  // customPrice.value = 0
  const { colors: cs } = convertSpuToSimpleSpu(data)
  colors.value = cs.sort(sortBy('value', false))
  // customSpu.value = value
  customSpu.value.price_detail.custom_price?.forEach((r: CustomPrice) => {
    if (!r.technologies)
      r.technologies = []
    if (r.technologies?.length)
      r.technology = r.technologies[0]
    else
      r.technology = {
        id: undefined,
        name: t('DesignShare.DssAddToCart.printing')
      } as Technology
  })
  image.value = convertToCustomizedImage(value.customizedImages[0])
  if (colors.value.length > 0) {
    colorChange(colors.value[0])
  }
  // spuImage.value = value.image[0]
  const altImage = image.value?.altImages
  alt_image.value = altColorSelect(altImage)
  currentCustomizedImage.value = currentCustomSpuData.value?.customizedImages[0]
}

const structurePriceDetail = (value: CustomSpu) => {
  const data = {} as CustomPriceDetail
  data.spu_price = value.spu.price.toString()
  // data.discount_amount_scale = customSpu.discount_amount_scale
  // data.customized_areas_scale = customSpu.customized_areas_scale
  const custom_price = [] as Array<CustomPrice>
  for (let index = 0; index < value.customizedImages.length; index++) {
    const image = value.customizedImages[index]
    if (image.customableImage) {
      let customized_areas_scale_title = ''
      image.customableImage?.scales?.forEach((scale: any) => {
        if (scale.customized_areas_scale == image.customized_areas.customized_areas_scale) {
          customized_areas_scale_title = scale.title
        }
      })
      let minTechnologyPrice: Technology = {
        id: 0,
        name: '',
        price: 0
      }
      if (image.customableImage.technologies && image.customableImage.technologies?.length) {
        minTechnologyPrice = image.customableImage.technologies[0]
        image.customableImage.technologies.forEach((res: Technology) => {
          if (minTechnologyPrice.price > res.price)
            minTechnologyPrice = res
        })
      }
      // let dss_image_price = '0'
      // if (value.references && value.references.length > 0) {
      //   value.references.forEach((ref: any) => {
      //     if (ref.product_spu_customable_image_id == image.customableImage.id && ref.type == 2) {
      //       dss_image_price = new BigNumber(ref.customizedImage.ref_price).plus(dss_image_price).toFixed(2)
      //     }
      //   })
      // }
      custom_price.push({
        id: image.customableImage.id,
        name: image.customableImage.name,
        price: image.customableImage.price.toString(),
        discount_amount_scale: image.customized_areas.discount_amount_scale || '1',
        customized_areas_scale: image.customized_areas.customized_areas_scale || '1',
        customized_areas_scale_title,
        technology: minTechnologyPrice
      })
    }
  }
  data.custom_price = custom_price
  data.spu_discount = baseDiscount
  if (customSpu.value)
    customSpu.value.price_detail = data
}
const altColorSelect = (altImage: any) => {
  const altArr = [] as any
  altImage?.forEach((alt: AltImage) => {
    const data = {
      alt_image: alt.alt_image,
      color: alt.attrs ? alt.attrs[0].object_value : {}
    }
    altArr.push(data)
  })
  return altArr
}
// 隐藏
const reset = () => {
  quantity.value = 1
  selectedSize.value = ''
  selectedColor.value = undefined
  customSpu.value = undefined
  productTypes.value = []
}

// 加入购物车
const addProduct = async () => {
  if (selectedColor.value !== undefined && selectedSize.value !== '') {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const item: any = {
      spu_custom_areas: {},
    }

    if (customSpu.value?.customizedImages) {
      item.spu_customable_image_id = []
      customSpu.value?.customizedImages.forEach((r) => {
        item.spu_customable_image_id.push(r.customableImage.id)
      })
    }

    // 只保存选择 不保存价格
    if (customSpu.value?.price_detail.custom_price) {
      item.technology = []
      customSpu.value?.price_detail.custom_price.forEach((r) => {
        if (r.technology)
          item.technology.push({
            id: r.technology?.id,
            name: r.technology?.name.length ? r.technology?.name : t('DesignShare.DssAddToCart.printing')
          })
      })
    }
    item.is_custom = true
    item.spu_name = customSpu.value?.spu_name
    item.spu_id = customSpu.value?.spu_id
    item.custom_spu_name = customSpu.value?.name
    item.quality = quantity.value
    item.custom_spu_id = customSpu.value?.custom_spu_id
    item.image = image.value?.customized_image
    item.spu_customable_image = findCustomableImage(selectedColor.value, image.value as CustomizedImage)
    item.spu_custom_width = image.value?.width
    item.spu_custom_height = image.value?.height
    item.spu_custom_areas = image.value?.custom_areas
    item.sku_price = customSpu.value!.price_detail.sku_price || undefined
    item.references = customSpu.value!.references
    const customSku = selectedCustomSkus.value[0] || {}
    if (customSku) {
      item.custom_sku_id = customSku.id
      item.sku_id = customSku.sku?.id
      item.sku_code = customSku.code
      const skuAttrs = customSku.sku?.attrs
      item.sku_attrs = skuAttrs?.filter(a => {
        // @Todo
        return a.attribute.key === 'color' || a.attribute.key === 'size' || a.attribute.key === 'weight'
      })
    }
    return await shoppingCart.addItem(item).then(() => {
      shoppingCart.fetch()
      message.success(t('DesignShare.DssAddToCart.hintSuccess'))
    })
  }
  else {
    return Promise.reject()
  }
}

defineExpose({
  setProduct,
  addProduct,
  reset,
})
</script>
<style scoped lang="less">
.product-information {
  display: flex;

  .custom-spus {
    width: 40%;
    height: 100%;

    .card {
      height: 100%;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;

      .title {
        display: flex;
        height: 55px;
        padding: 15px 32px;
        border-bottom: 1px solid #e9e9e9;
        align-items: center;

        h4 {
          margin: 0 0 0 10px;
        }
      }

      .content {
        flex: 1;
        width: 100%;
        display: flex;
        padding: 20px;
        box-sizing: border-box;
        gap: 20px;

        .aside {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;

          .top {
            flex: 1;
            display: flex;
            background-color: #f6f6f6;

            .big {
              width: 400px;
              height: 400px;
              display: flex;
              flex: 1;
              justify-content: center;
              align-items: center;

              @-moz-document url-prefix() {
                :deep(.fabric-div) {
                  width: 400px !important;
                  height: 400px !important;
                }

                :deep(.canvas-container) {
                  width: 400px !important;
                  height: 400px !important;
                }

                :deep(.lower-canvas) {
                  width: 400px !important;
                  height: 400px !important;
                }

                :deep(.upper-canvas) {
                  width: 400px !important;
                  height: 400px !important;
                }
              }
            }
          }

          .thumbnail {
            width: 100%;
            height: 100px;
            display: flex;
            margin-top: 15px;
            margin-bottom: 15px;
            overflow-x: scroll;
            overflow-y: hidden;

            .hidden {
              width: 100px;
              height: 100px;
              position: absolute;
              visibility: hidden;
              display: block;
            }

            .thumbnail-container {
              width: 100px;
              height: 100px;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-right: 15px;

              @-moz-document url-prefix() {
                :deep(.fabric-div) {
                  width: 100px !important;
                  height: 100px !important;
                }

                :deep(.canvas-container) {
                  width: 100px !important;
                  height: 100px !important;
                }

                :deep(.lower-canvas) {
                  width: 100px !important;
                  height: 100px !important;
                }

                :deep(.upper-canvas) {
                  width: 100px !important;
                  height: 100px !important;
                }
              }
            }
          }

          .operation {
            display: flex;
            gap: 10px;

            button {
              height: 40px;
              width: 50%;
            }
          }
        }
      }

      .box {
        padding: 5px 5px;
        margin-right: 15px;
        margin-bottom: 15px;
        border: 1px solid #f5f5f5;
        background-color: #eff1f4;
      }
    }
  }

  .technology {
    display: flex;
    align-items: center;

    .technology-radio {
      margin-left: 10px;
    }
  }

  .product {
    flex: 1;
    font-size: 14px;
    font-family: 'Microsoft YaHei';
    font-weight: 400;
    color: #111111;

    .selling-price {
      margin-top: 18px;
    }

    .price {
      margin-left: 5px;
      color: #FAAD14;
      font-size: 15px;
    }

    .spuInfo {
      border-bottom: 1px solid #f3f3f3;
      margin-bottom: 10px;
      display: flex;
      align-items: center;

      .hidden {
        width: 100px;
        height: 100px;
        position: absolute;
        visibility: hidden;
        display: block;
      }

      .viewer {
        width: 100px;
        height: 100px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;

        @-moz-document url-prefix() {
          :deep(.fabric-div) {
            width: 100px !important;
            height: 100px !important;
          }

          :deep(.canvas-container) {
            width: 100px !important;
            height: 100px !important;
          }

          :deep(.lower-canvas) {
            width: 100px !important;
            height: 100px !important;
          }

          :deep(.upper-canvas) {
            width: 100px !important;
            height: 100px !important;
          }
        }
      }
    }

    .options {
      .product-select {
        :deep(.ant-space-item .ant-select) {
          width: 300px !important;
        }
      }

      .colorTitle,
      .sizeTitle,
      .countTitle {
        margin: 20px 0 10px 0;
        font-size: 16px;
      }

      .hidden {
        width: 35px;
        height: 35px;
        position: absolute;
        visibility: hidden;
        display: block;
      }

      .viewer {
        width: 35px;
        height: 35px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .colors {
        display: flex;
        flex-wrap: wrap;
        gap: 14px;
        align-items: center;

        .color-item {
          width: 35px;
          height: 35px;
          border: 1px solid #cdcdcd;
          cursor: pointer;
        }

        .color-selected {
          border: 1px solid #111;
        }
      }

      .size-content {
        display: flex;
        margin-bottom: 18px;
        flex-wrap: wrap;
        gap: 10px;

        .size-item {
          border: 1px solid #d9d9d9;
          padding: 0 10px;
          cursor: pointer;
          height: 40px;
          min-width: 140px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .size-selected {
          background-color: #111111;
          color: white;
        }
      }

      .quantity-input {
        width: 124px;
        text-align: center;

        :deep(.ant-input-group-addon) {
          padding: 0;
          width: 32px;
          height: 32px;
        }

        :deep(.ant-input) {
          height: 32px;
          padding: 0;
        }

        .input-change {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          background-color: #F6F6F6;
        }

        .input-disabled {
          cursor: not-allowed;
        }
      }
    }
  }
}
</style>
